import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  whiteBackground: {
    backgroundColor: colors.white,
  },
  container: {
    marginLeft: '45px',
    marginRight: '45px',
    paddingTop: '45px',
    paddingBottom: '45px',
    backgroundColor: colors.gray.l96,
    [theme.breakpoints.down(1279)]: {
      marginLeft: '24px',
      marginRight: '24px',
    },
    [theme.breakpoints.down(600)]: {
      marginLeft: '0px',
      marginRight: '0px',
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '32px',
    letterSpacing: '0.15px',
    textAlign: 'center',
    marginBottom: '24px',
    [theme.breakpoints.down(600)]: {
      fontSize: '19px',
      marginBottom: '32px',
      marginLeft: '24px',
      textAlign: 'left',
    },
  },
  accordionContainer: {
    display: 'none',
    [theme.breakpoints.down(1580)]: {
      display: 'block',
      marginLeft: '17%',
      marginRight: '17%',
    },
    [theme.breakpoints.down(600)]: {
      display: 'block',
      marginLeft: '24px',
      marginRight: '24px',
    },
  },
  gridContainer: {
    margin: 'auto',
    maxWidth: '1440px',
    [theme.breakpoints.down(1580)]: {
      display: 'none',
    },
  },
}));
